import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconReturn = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 10 10",
	fill: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M3.467 8.71a.47.47 0 0 1-.508-.089L.146 5.965a.465.465 0 0 1 0-.68L2.96 2.63a.469.469 0 0 1 .791.34v1.719H7.5c.346 0 .625-.28.625-.625V1.25c0-.346.28-.625.625-.625h.625c.346 0 .625.28.625.625v2.813a2.5 2.5 0 0 1-2.5 2.5H3.75V8.28a.47.47 0 0 1-.283.43" })
});
export default SvgIconReturn;
